// src/components/BottomButton.tsx
import React from 'react';
import PrimaryButton from './PrimaryButton';

interface BottomButtonProps {
  text: string;
  onClick: () => void;
  disable?: boolean;
}

const BottomButton: React.FC<BottomButtonProps> = ({ text, onClick, disable }) => {
  return (
    <div className="">
      <div className="flex space-x-2">
        <PrimaryButton text={text} onClick={onClick} disable={disable} />
      </div>
    </div>
  );
};

export default BottomButton;
